import { Link, Navigate, Route, Routes, useLocation } from 'react-router-dom';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { IconButton, Tab, Tabs, Typography } from '@mui/material';
import Component from '../../components/Component';
import DailyTasksCalendarPage from './DailyTasksCalendarPage';
import DailyTasksDayPage from './DailyTasksDayPage';
import WheelTemplatesPage from './WheelTemplatesPage';
import WheelSettingsPage from './WheelSettingsPage';
import BonusMilestonesPage from './BonusMilestonesPage';

function dailyTasksTab(pathname) {
  if (pathname.includes('/wheel-templates')) return 'templates';
  if (pathname.includes('/wheel')) return 'wheel';
  if (pathname.includes('/milestones')) return 'milestones';
  return 'schedule';
}

function DailyTasks() {
  const location = useLocation();
  const tabValue = dailyTasksTab(location.pathname);
  const onDayEditor = /\/(day\/)?\d{4}-\d{2}-\d{2}/.test(location.pathname);

  return (
    <Component>
      <div
        className="daily-tasks-container"
        style={{
          marginLeft: '280px',
          marginTop: '80px',
          padding: '20px',
          width: 'calc(100% - 280px)',
        }}
      >
        <div className="d-flex align-items-center mb-2">
          <IconButton style={{ background: '#FFFFFF' }} component={Link} to="/">
            <ArrowBackIcon />
          </IconButton>
          <div style={{ marginLeft: '12px' }}>
            <h2 style={{ margin: 0 }}>Daily Tasks</h2>
            <Typography variant="body2" color="text.secondary">
              Schedule each IST day — missions, FE wheel template, daily challenges, Have Your Say,
              and Fan of the Day. Mission packs stay on{' '}
              <Link to="/admin/daily-missions?from=today">Daily Missions</Link>.
            </Typography>
          </div>
        </div>

        {!onDayEditor && (
          <Tabs value={tabValue} sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
            <Tab label="Schedule" value="schedule" component={Link} to="/admin/daily-tasks" />
            <Tab
              label="Wheel templates"
              value="templates"
              component={Link}
              to="/admin/daily-tasks/wheel-templates"
            />
            <Tab
              label="Global wheel"
              value="wheel"
              component={Link}
              to="/admin/daily-tasks/wheel"
            />
            <Tab
              label="Bonus milestones"
              value="milestones"
              component={Link}
              to="/admin/daily-tasks/milestones"
            />
          </Tabs>
        )}

        <Routes>
          <Route index element={<DailyTasksCalendarPage />} />
          <Route path="wheel-templates" element={<WheelTemplatesPage />} />
          <Route path="wheel" element={<WheelSettingsPage />} />
          <Route path="milestones" element={<BonusMilestonesPage />} />
          <Route path="day/:date" element={<DailyTasksDayPage />} />
          <Route path=":date" element={<DailyTasksDayPage />} />
          <Route path="*" element={<Navigate to="/admin/daily-tasks" replace />} />
        </Routes>
      </div>
    </Component>
  );
}

export default DailyTasks;
